export default "__VITE_ASSET__BIR6TWJ2__"